"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestQueryFieldsCodec = void 0;
const t = __importStar(require("io-ts"));
const io_ts_types_1 = require("io-ts-types");
const codecs_1 = require("../codecs");
const field_codec_1 = require("./field-codec");
const FiledWithScore = t.union([field_codec_1.Field, t.literal('score')]);
const moreThanOperator = t.type({
    field: FiledWithScore,
    value: t.number,
    operator: t.literal('moreThan'),
});
const moreThanOrEqualToOperator = t.type({
    field: FiledWithScore,
    value: t.number,
    operator: t.literal('moreThanOrEqualTo'),
});
const lessThanOperator = t.type({
    field: FiledWithScore,
    value: t.number,
    operator: t.literal('lessThan'),
});
const lessThanOrEqualToOperator = t.type({
    field: FiledWithScore,
    value: t.number,
    operator: t.literal('lessThanOrEqualTo'),
});
const equalToOperator = t.type({
    field: FiledWithScore,
    value: t.union([t.number, t.string, t.boolean]),
    operator: t.literal('equalTo'),
});
const startsWithOperator = t.type({
    field: field_codec_1.Field,
    value: t.string,
    operator: t.literal('startsWith'),
});
const includesOperator = t.type({
    field: field_codec_1.Field,
    value: t.string,
    operator: t.literal('includes'),
});
const isNullOperator = t.type({
    field: field_codec_1.Field,
    value: t.boolean,
    operator: t.literal('isNull'),
});
const inArrayOperator = t.type({
    field: field_codec_1.Field,
    value: t.array(t.union([t.number, t.string, t.boolean])),
    operator: t.literal('inArray'),
});
exports.RequestQueryFieldsCodec = t.exact(t.type({
    fields: t.array(field_codec_1.Field),
    limit: (0, io_ts_types_1.optionFromNullable)(codecs_1.PositiveIntegerLessThanOrEqualTo1000Codec),
    offset: (0, io_ts_types_1.optionFromNullable)(codecs_1.PositiveIntegerCodec),
    orderBy: (0, io_ts_types_1.optionFromNullable)(t.array(t.type({
        field: FiledWithScore,
        direction: t.union([t.literal('asc'), t.literal('desc')]),
    }))),
    filter: (0, io_ts_types_1.optionFromNullable)(t.array(t.union([
        moreThanOperator,
        moreThanOrEqualToOperator,
        lessThanOperator,
        lessThanOrEqualToOperator,
        equalToOperator,
        startsWithOperator,
        includesOperator,
        isNullOperator,
        inArrayOperator,
    ]))),
    tags: (0, io_ts_types_1.optionFromNullable)(t.array(t.type({
        strategy: t.union([t.literal('include'), t.literal('exclude')]),
        value: t.string,
    }))),
    search: (0, io_ts_types_1.optionFromNullable)(t.string),
    heatFilterId: (0, io_ts_types_1.optionFromNullable)(io_ts_types_1.UUID),
}));
//# sourceMappingURL=types.js.map